// src/components/Login.js
import React, { useContext, useEffect, useRef, useState, useLayoutEffect, forwardRef } from 'react';
import { useInView } from 'react-intersection-observer';
import AuthInput from '../AuthUI/auth_Input';
import { ManagerContext } from '../../contexts/ManagerContext';
import { OpenAiContext } from '../../contexts/OpenAiContext';
import { UiContext } from '../../contexts/UiContext';
import { Box, 
  Fade,
  Container, 
  ListItem, 
  Collapse, 
  List, 
  Tooltip, 
  ListItemText, 
  ListItemButton, 
  CardContent, 
  Typography, 
  Grow, 
  Stack, 
  Pagination, 
  IconButton, 
  Button, 
  Skeleton,
  Avatar,
  CircularProgress  } from '@mui/material'
// import GrowOnView from '../GrowOnView';

import ReadMoreIcon from '@mui/icons-material/ReadMore';
import { isMobile } from 'react-device-detect';
import MarkdownComponent from '../AvatarStatic/MarkdownComponent';
import RefreshIcon from '@mui/icons-material/Refresh';
import  './ChatContainer.css';
import MuiBox from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Portal from '@mui/material/Portal';
import { TransitionGroup } from 'react-transition-group';
// import { Buffer } from 'buffer';
import SimpleBackdrop from '../SimpleBackDrop';


// @ts-ignore
// window.Buffer = Buffer;



import ReactDOM from 'react-dom';
import { set } from 'zod';
import { Messages } from 'openai/resources/beta/threads/messages.mjs';

const GrowOnView = ({ children }) => {
  const [ visible, setVisible ] = React.useState(false)
  const { ref, inView } = useInView({
    threshold: 0.1, // zmieniaj według potrzeb
  });

  React.useEffect(() => {
    if (inView) {
        setVisible(true)
    }
}, [inView]);

  return (
    <Box
      ref={ref}
      sx={{
        transition: 'transform 0.3s ease, opacity 0.3s ease',
        transform: visible ? 'scale(1)' : 'scale(0.5)',
        opacity: visible ? 1 : 0,
      }}
    >
      {children}
    </Box>
  );
};

function MyOverflowElement({ children }) {
  return ReactDOM.createPortal(
    <div style={{ position: 'absolute', top: 0, left: 0, zIndex: 999 }}>
      {children}
    </div>,
    document.body
  );
}

function ScrollBarPortal({ children, style }) {
  return (
    <Portal container={document.body}>
      <Box sx={{ 
          position: 'fixed',
          // Ustaw odpowiednie pozycjonowanie, by odpowiadało Twoim potrzebom
          top: '20px',  
          left: '16px', 
          width: 'calc(100vw - 32px)',
          height: 'calc(100vh - 40px)',
          pointerEvents: 'none', // jeżeli chcesz, żeby nie przechwytywał zdarzeń
          ...style
        }}>
        {children}
      </Box>
    </Portal>
  );
}

const BoxSpecial = styled(MuiBox)(
  ({ theme, visible }) => ({
    height: visible?'100%':0,
    transition: theme.transitions.create([ 'height' ], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.standard,
    })
  }),
);

const TypingEffect = React.memo(( { text } ) => {
    const [ displayedText, setDisplayedText ] = useState('');
    const textRef = useRef(text);
    const element = useRef(null);
    
    useEffect(() => {
      textRef.current = text;
      let index = 0;
      let interval;
  
      if (text) {
        // Reset displayedText at the start of typing
        setDisplayedText(''); // Reset display text on new input
        index = 0; // Reset index on new text
        
        interval = setInterval(() => {
          if (index < textRef.current.length) {
            setDisplayedText(prev => prev + textRef.current[index]);
            index++;
          } else {
            clearInterval(interval);
          }
        }, 30);
      }

      return () => clearInterval(interval);
    }, [text]);

    return (
      <Tooltip title={text} centered sx={{}}>
        <ListItemText 
        ref = {(el) => (element.current = el)}
        primary={displayedText} 
        sx={{ pl: 5, pr: 5, placeItems: 'center' }}
        primaryTypographyProps={{ fontSize: {xs: '1rem', sm: '1.3rem'}, fontWeight: '600'}}/>
      </Tooltip>
    );
  });

const ChatContainer = forwardRef(( { size, messages, _chat, _setChat, setMessages, activeRun, setActiveRun }, ref ) => {
  const { closeBackDrop } = useContext(UiContext);

  const containerRef = useRef(null); // Referencja do kontenera
  const elementRefs = useRef([]);
  const sofiaRef = useRef(null);
  const [ activePaginationIndex, setActivePaginationIndex ] = useState(null);
  const [ paginationStates, setPaginationStates ] = useState({});
  const [ _index, _setIndex ] = useState([]);
  const color1 = 'hsla(0, 0.00%, 49.80%, 0.75)'
  const { currentUser, sendTask, connectionState } = useContext(ManagerContext);
  const { openai,
    stream, setStream,
    forwardAuto, setForwardAuto,
    fetch_title, fetch_image,
    fetchThread, fetchAssistant, fetchMessages, fetchMessage, loadMoreMessages, updateMessage } = useContext(OpenAiContext);
  const [ position, setPosition ] = useState(0);
  const animRef = useRef(null);
  const theme = useTheme();
  const is_xs = useMediaQuery(theme.breakpoints.down('xs'));
  const [autoScroll, setAutoScroll] = useState(true);
  const [queue, setQueue] = useState([])
  const [ inProcess, setInProcess ] = useState(false)



  var wrapFunction = function(fn, context, params) {
    return function() {
        fn.apply(context, params);
    };
  }

  useEffect(() => {
    if(!stream || stream===undefined) return
    generateMessages(stream)
  }, [stream])

  useEffect(() => {
    setForwardAuto({func: setAutoScroll})
  }, []);

  const handle_thread_created = async (event) => {
    var thread
    if(_chat.threads.length === 0){
      thread = await openai.beta.threads.update(event.data.id, {
        metadata: { modified: "true", type: "linear" }
      });
    }else{
      thread = event.data;
    }
    const threadMessages = await fetchMessages(thread.id);
    console.timeEnd("thread_created");
    _setChat(prev => {
      // Zwracamy nowy obiekt stanu
      return {
        ...prev, // zachowujemy stare wartości
        threads: [...prev.threads, thread],
        activeThread: thread // ustawiamy aktywny wątek
      };
    });
    
    console.log('threadMessages', thread.id, threadMessages);
    setMessages(threadMessages.data);
    if (currentUser) sendTask('add_thread', { thread_id: thread.id })
    closeBackDrop();
    gtag('event', 'new_chat',{
      'event_category': 'chat',
      'event_label': 'User create new chat',
      'value': 1
    });
    }

  // OnChange Pagination – tylko aktualizujemy stan
  function handleChangePagination(index, value, len) {
    if (paginationStates===null){
      setPaginationStates(prev => ({
        ...prev,
        [index]: len // Przechowuj stronę dla konkretnego indeksu
      }));
    }else{
    // Przykładowo: zapisujemy (value-1) do stanu _index
      setPaginationStates(prev => ({
        ...prev,
        [index]: value || 0 // Przechowuj stronę dla konkretnego indeksu
      }));
      _setIndex(prev => {
        const newPrev = [...prev];
        newPrev[index] = value - 1;
        return newPrev;
      });
    }
    // Zapisujemy, że właśnie zmieniono tę grupę – użyjemy jej do korekty scrolla w useLayoutEffect
    setActivePaginationIndex(index);
  }

  const handle_thread_run_created = async (event) => {
    console.timeEnd("thread_run_created");
    console.time("update_message_list")
    console.time("thread_message_created");
    console.log('thread_run_created_________________________', event)
    _setChat(prev => {
      return {
        ...prev,
        activeRun: event.data
      }
    });
    // const threadMessages = await fetchMessages(event.data.thread_id);
    // setMessages(prev => [ ...threadMessages.data, ...prev ]);
    console.timeEnd("update_message_list")
  }

  const handle_thread_message_created = async (event) => {
    console.timeEnd("thread_message_created");
    setMessages(prev => {
      const newMessage = event.data;            
      const index = prev.findIndex(item => item.id === 'last');
      if (index !== -1) {
        const newPrev = [...prev];
        newPrev.splice(index, 1);
        return [newMessage, ...newPrev];
      }
      return [newMessage, ...prev];
    });
  }

  const handle_thread_message_delta = async (event) => {
    const deltaContent = event.data.delta.content[0]?.text.value || '';
    if (deltaContent) {
      // update content thread
      setMessages(prevMessages => {
        if (prevMessages.length === 0) return prevMessages; 
        const firstMessage = prevMessages[0]; 
        if (!firstMessage.content) firstMessage.content = [];
        if (firstMessage.content.length === 0){
          return [{
            ...firstMessage,
            content: event.data.delta.content // Ustawia nową wiadomość jako content
          }, ...prevMessages.slice(1)]; // Pozostaw resztę wiadomości
        }
        // Uzyskaj dostęp do ostatniego elementu content
        const lastContent = firstMessage.content[firstMessage.content.length - 1];
        // Utwórz nową treść, dodając nowe dane
        const updatedContent = [
          ...firstMessage.content.slice(0, -1), // Zwróć wszystkie przed ostatnim
          { 
            ...lastContent, 
            text: {
              ...lastContent.text,
              value: lastContent.text.value + deltaContent // Dodaj nowe dane do wartości
            }
          }
        ];
        // Zaktualizuj wiadomość z nowym content
        return [
          { ...firstMessage, content: updatedContent }, // Zaktualizuj pierwszy element
          ...prevMessages.slice(1) // Pozostaw resztę wiadomości
        ];
      });
    }
  }
  const handle_thread_message_completed = async (event, query) => {

    const threadMessages = await fetchMessages(event.data.thread_id, {limit:2});
    setActiveRun({...activeRun, state: 'ready'})
    setMessages(prev => [ ...threadMessages.data, ...prev ]);
    fetch_title(event.data.thread_id, query)
  }

  const handle_thread_run_completed = async (event, newMessage_id) => {
    // const model = event.data.model;
    // console.log('handle_thread_run_completed message_id:',messages[0].id)
    // updateMessage(event.data.thread_id, newMessage_id, metadata)
    // setMessages(prev => {
    //   const newPrev = [...prev];
    //   const index = newPrev.findIndex(item => item.id === event.data.thread_id);
    //   if (index !== -1) {
    //     newPrev[index].metadata = metadata
    //     return newPrev;
    //   }
    //   return prev;
    // })
  }


  const generateMessages = async (stream, query) => {
    console.log('generateMessages', stream)
    var firstDelta = true
    var newMessage_id = null
    var thread_id = null

    
    try{
      for await (const event of stream) {
        if (event.data?.object==="thread.run"){
          if (event.data.status === 'queued') {
            console.log('status', event.data.status)
            setActiveRun({...activeRun, run: event.data, state: 'run'})
          } else
          if (event.data.status === 'in_progress') {
            console.log('status', event.data.status)
            setActiveRun({...activeRun, run: event.data, state: 'run'})
          } else
          if (event.data.status === 'completed') {
            console.log('status', event.data.status)
            setActiveRun({...activeRun, state: 'ready'})
          } else
          if (event.data.status === 'failed') {
            console.log('status', event.data.status)
            setActiveRun({...activeRun, state: 'error'})
          }
        }
        if (event.event === 'error') {
          throw new Error(event.message || 'Wystąpił nieokreślony błąd.');
        }
        if (event.event === 'thread.created'){
          console.log('thread_created')
          thread_id = event.data.id
          await handle_thread_created(event);
          // var fun = wrapFunction(handle_thread_created, this, [event]);
          // queue = [...prev, fun]
        }
        if (event.event === 'thread.run.created') {
          console.log('thread_run_created')
          handle_thread_run_created(event);
          // var fun = wrapFunction(handle_thread_run_created, this, [event]);
          // queue = [...prev, fun]
        }
        if (event.event === 'thread.message.created') {
          newMessage_id = event.data.id
          console.log('thread_message_created')
          await handle_thread_message_created(event);
          var fun = wrapFunction(handle_thread_message_created, this, [event]);
          // queue = [...prev, fun]
          // setAutoScroll(true)
        }
        if (event.event === 'thread.run.cancelling') {
          console.log('thread_run_cancelling', event.data)
          // const messages = fetchMessages(event.data.thread_id)
          
          setMessages(prev => {
            const newPrev = [...prev];
            const _newPrev = newPrev.filter(item => item.id !== newMessage_id)
            console.log('thread_run_cancelling newPrev', newMessage_id, _newPrev)
            return _newPrev;
          })
          const message = await openai.beta.threads.messages.del(event.data.thread_id, newMessage_id)
          console.log('delated:', message)
          setActiveRun({...activeRun, state: 'ready'})
        }
        
        
        if (event.event === 'thread.message.delta') {
          if (firstDelta){
            console.timeEnd('thread_first_delta');
            firstDelta = false
            setAutoScroll(true)
          }
          await handle_thread_message_delta(event);
          // var fun = wrapFunction(handle_thread_message_delta, this, [event]);
          // queue = [...prev, fun]
        }
        if (event.event === 'thread.message.completed') {
          console.log('thread_message_completed')
          await handle_thread_message_completed(event, query);
          // var fun = wrapFunction(handle_thread_message_completed, this, [event, query]);
          // queue = [...prev, fun]
        }
        if (event.event === 'thread.run.completed') {
          console.log('thread_run_completed')
          await handle_thread_run_completed(event, newMessage_id);
          // var fun = wrapFunction(handle_thread_run_completed, this, [event]);
          // queue = [...prev, fun]
        }
      }
    }
    catch(error) {
      console.error('Błąd w stream run:', error);
      closeBackDrop()
    }
  }

  const startRun = async (thread_id) => {
    console.log('startRun', thread_id)
    setActiveRun({...activeRun, state: 'wait'})
    const stream = await openai.beta.threads.runs.create(
      thread_id,
      {
        assistant_id: _chat.assistant_id,
        stream: true,
        model: 'gpt-4o-mini',
      }
    );
    generateMessages(stream, thread_id);
  }

  useLayoutEffect(() => {
    if (
      activePaginationIndex !== null &&
      containerRef.current &&
      elementRefs.current[activePaginationIndex]
    ) {
      const targetElement = elementRefs.current[activePaginationIndex];
      const targetBottom = targetElement.offsetTop + targetElement.offsetHeight;
      const containerHeight = containerRef.current.clientHeight;
      setPosition(targetBottom - containerHeight)
    }
  }, [activePaginationIndex, _index]); 

  useEffect(() => {
    if(autoScroll || false){
      setTimeout(() => {
        if (containerRef.current) {
          // Płynne przewijanie na sztywno do dołu
          // containerRef.current.scrollTop = containerRef.current.scrollHeight;  
        }
        animRef.current = null; // Resetowanie referencji
      }, 600); // Opóźnienie 1 sekundy
    }
  }, [messages])

  const title = () => {
    if ( _chat.activeThread === 'new_chat') return 'NEW CHAT'
    
    const thread = _chat.threads?.find(item => item.id === _chat.activeThread.id)
    if (!thread) return {};
    return thread.metadata?.name
  }

  return (
      <Box 
      sx={{ 
        
        padding: 'unset',
        // paddingLeft: '16px',
        paddingBottom: '16px',
        // paddingRight: '16px',
        textAlign: 'center',
        width: {xs:'100vw', sm: '100%'}, 
        height: `calc(${size==='small'?80:100}dvh - 60px)`,
        fontSize: {xs: '1rem', md: '1.3rem'}
        // backgroundColor: colorBase,
        
        }} 
        variant={'outlined'}>
          
        <CardContent sx={{  
          display: 'flex',
          height: '100%',
          flexDirection: 'column',
          justifyContent: 'center',
          
          
        }}>
              {size !== 'small' && messages?.length>0 && 
                <Grow in={  title() !== '' && title() !== undefined && _chat.activeThread !== null && (messages?.length !== 0) } sx={{  ml:10, padding: '5px', alignSelf: 'center',
                  mr:10,mt: 1}}>
                  <ListItem
                  sx={{
                    backgroundColor: color1,
                    boxShadow: 'rgba(127, 127, 127, 0.75) 0px 0px 10px 10px',
                    justifySelf: 'center',
                    color: 'black',
                    ml:10,
                    mr:10,
                    border: 'solid #00000029',
                    display: 'flex',
                    laceItems: 'center',
          
                    width: 'fit-content',
                    margin: '5px',
                    
                    padding: '5px',
                    borderRadius: '10px',
                    marginBottom: '20px',
                    
                  }}>
                    <TypingEffect text={title()}/>
                  </ListItem>
                </Grow>}
              {/* </Container>} */}
              {size === 'small' && <Container sx={{  height:'10px'}}> </Container>}
        {messages?.length>0&&<BoxSpecial
          visible = {messages?.length>0}
          id="containerDiv"
          ref = {(el) => (containerRef.current = el)}
          sx={{
            position: 'relative',
            overflowY: messages.length>0?'auto': 'hidden',
            overflowX: 'hidden',
            borderRadius: '20px',
            transition: 'scroll-top 0.5s ease',
            transition: 'height 0.3s ease',
            padding: '10px',
            paddingTop: '20px',
            display: 'flex',
            flexDirection: 'column-reverse',
            mb: size === 'small'?0:2,
            maskImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 3%, rgb(0, 0, 0) 97%, rgba(0, 0, 0, 0) 100%)'
          }}
          className="scroll-container"
          >
            <List sx={{ marginLeft: '5%', mr: '5%' }}>
            <TransitionGroup>
              {messages.slice().reverse().map((item, index) => {
                if (item?.metadata?.visible !== 'hidden') {
                  return (
                    <Collapse 
                    ref={el => {
                      if (el && !elementRefs.current.includes(el)) {
                          elementRefs.current.push(el);
                      }}}
                    key={item.id}> {/* Upewnij się, że używasz czegoś unikalnego dla klucza */}
                      <GrowOnView>
                        {renderItem(item, item, index, messages.length)}
                        {item.metadata?.type === "meta" && renderItem(JSON.parse(item.metadata?.meta), item, index, messages.length)}
                      </GrowOnView>
                      {item?.metadata?.type === 'divider' && <div style={{ height: '50px' }}></div>}
                      
                    </Collapse>
                  );
                }
                return null; // Upewnij się, że nie zwracasz niczego, jeśli element jest ukryty
              })}
              </ TransitionGroup>
            </List>
          </BoxSpecial>}
          <Container >
            {/* <Grow in={(chat.activeThread !== null || chat.activeThread === 'new_chat') && */}
              {/* ((messages?.length !== 0) || chat.activeThread === 'new_chat') } > */}
              {(_chat.activeThread !== null || _chat.activeThread === 'new_chat') &&
              ((messages?.length !== 0 || true) || _chat.activeThread === 'new_chat') &&
              <ListItem sx={{ justifyContent: 'center'}}>
                <AuthInput 
                  setAutoScroll={setAutoScroll}
                  chat={_chat} 
                  setChat={_setChat}
                  messages={messages} 
                  setMessages={setMessages} 
                  activeRun={activeRun} 
                  setActiveRun={setActiveRun} 
                  generateMessages={generateMessages}
                />
              </ListItem>}
            {/* </Grow> */}
          </Container>  
        </CardContent>
      </Box>
    );

    function renderItem(item, len, index, last) {
      return (
          <ListItem
            
            sx={{
              backgroundColor: color1,
              boxShadow: 'rgba(127, 127, 127, 0.75) 0px 0px 10px 10px',
              justifySelf: item.role === 'user' ? 'end' : item.role=== 'assistant' ? 'start' : 'center',
              border: 'solid #00000029',
              height: 'fit-content',
              display: 'flex',

              width: item.role === 'user'||item.role === 'system'?'fit-content':'90%',
              maxWidth: '90%',
              minWidth: item.id==='has_more'?'unset':'300px',
              margin: '5px',
              padding: '5px',
              borderRadius: '10px',
              marginBottom: '20px',
              justifyContent: item.id==='has_more'?'center':'unset',
              // transform: `skewY(${item.role === 'user'? isMobile?1:0.5:isMobile?-1:-0.5}deg)`
              
            }}>
              <Stack direction='column' sx={{ width: '100%' }}>
                {item.id === 'has_more' && 
                <Button variant="contained" startIcon={ <ReadMoreIcon />} sx={{ width: '100%', borderRadius: '10px'}} onClick={ () => { loadMoreMessages(item.last_id) } } >load previous</Button>}
              {console.log('item', item)}
            
              {item?.type === 'Skeleton'?  
               <Box sx={{ width: '100%' }}>
                <Skeleton animation="wave" variant="circular" width={70} height={70} />
                <Skeleton />
                <Skeleton animation="wave" sx={{ width: '80%' }} />
                <Skeleton animation="wave" sx={{ width: '60%' }} />
                <Skeleton animation="wave" sx={{ width: '70%' }} />
                <Skeleton animation="wave" sx={{ width: '40%' }} />
                <Skeleton animation="wave" sx={{ width: '80%' }} />
                <Skeleton animation={false} />
              </Box>  
              

              :(item.role !== 'system' && <MarkdownComponent setMessages={setMessages} fetch_image={fetch_image} openai={openai} status={activeRun.state} currentUser={currentUser} message={item} />)
              }
              
            {size!=='small' && false && <Stack  direction='row' spacing={1} sx={{ alignItems: 'center', opacity: 1 }}>
              <Typography >
                {item.created_at}
              </Typography>
              <Typography >
                {item.metadata?.model}
              </Typography>
              <Typography >
                {item.status}
              </Typography>
              <Typography >
                {item.id}
              </Typography>
            </Stack>}
            </Stack>
          </ListItem>
      );
    }
});

export default ChatContainer;